import React from 'react';
import { createLazyPage } from '../createLazyPage';
import { AppRouteDefinition } from '../routeDefinition';

const WelcomePage = createLazyPage(
  () => import('@app/pages/WelcomePage/WelcomePage')
);

const ProfilePage = createLazyPage(
  () => import('@app/pages/Profile/ProfilePage')
);

export const baseRoutes: AppRouteDefinition[] = [
  {
    key: 'home',
    index: true,
    element: <WelcomePage />,
  },
  {
    key: 'profile',
    path: 'profile',
    element: <ProfilePage />,
  },
];
